import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IPopcornRepository } from '../../repositories/interfaces/iPopcornRepository';
import { IGetRewindParams } from '../../../entity/interface/iPopcorn';

export interface iGetRewaindsUseCase {
    execute(searchParams: IGetRewindParams): Promise<any>;
}

export class GetRewindUseCase implements iGetRewaindsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getRewinds(): IPopcornRepository {
        return container.resolve<IPopcornRepository>(DI.REPOSITORIES.IPopcornRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(searchParams: IGetRewindParams): Promise<any> {
        return await this.getRewinds.getRewind(searchParams);
    }
}
